// extracted by mini-css-extract-plugin
export default {"academicsSection":"Academics_academicsSection__EU2sY","timetable":"Academics_timetable__zGECN","list-group-item":"Academics_list-group-item__y7EZ0"};